import { createContext, useContext, useState, type ReactNode } from 'react';

interface VerifyAgentContextType {
    isOpen: boolean;
    openVerifyAgent: () => void;
    closeVerifyAgent: () => void;
}

const VerifyAgentContext = createContext<VerifyAgentContextType | undefined>(undefined);

export const VerifyAgentProvider = ({ children }: { children: ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openVerifyAgent = () => setIsOpen(true);
    const closeVerifyAgent = () => setIsOpen(false);

    return (
        <VerifyAgentContext.Provider value={{ isOpen, openVerifyAgent, closeVerifyAgent }}>
            {children}
        </VerifyAgentContext.Provider>
    );
};

export const useVerifyAgent = () => {
    const context = useContext(VerifyAgentContext);
    if (!context) {
        throw new Error('useVerifyAgent must be used within a VerifyAgentProvider');
    }
    return context;
};
